import commonFun from "@/utils/commonFun";
//时间格式化
import Moment from 'moment'
import i18n from "@/components/common/i18n";
import { Decimal } from "decimal.js";
var env = process.env.NODE_ENV
export default {

    ic(value, table, field) {
        let icValue = commonFun.getICVal(table, field, value);
        // console.log('icValue',icValue);
        if (!!icValue) {
            value = icValue;
        }
        return value;
    },
    dateFormatFilter(data, formatStr = 'YYYY-MM-DD') {
        if (!!data) {
            return Moment(data).format(formatStr);
        } else {
            return "";
        }
    },
    subStr(val, length) {

    },
    inputChoiceI18n(inputChoiceObj) {
        //国际化语言
        let language = i18n.locale;
        if (language != 'en-US') {
            return inputChoiceObj.chineseValue;
        } else {
            return inputChoiceObj.englishValue
        }
    },
    upper(val) {
        if (commonFun.isNotEmpty(val)) {
            return val.toUpperCase();
        }
    },
    chineseNum(num) {
        return commonFun.toChinesNum(num);
    },
    romanNum(num) {
        return commonFun.toRomanNum(num);
    },
    thousandSeparatorAnd(input) {
        var num = input
        if (num) {
            num = parseFloat(input).toFixed(2)
        }
        return num && num.toString().replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
    },
    thousandSeparator(input) {

        return input && input.toString().replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
    },
    percentSeparator(input) {
        if (!input) {
            return ''
        } else {
            let value = new Decimal(input).mul(new Decimal(100));
            // console.log("🚀 ~ file: filters.js:55 ~ percentSeparator ~ value:", value)
            value = value.toNumber().toFixed(2, Decimal.ROUND_HALF_UP)
                // console.log("🚀 ~ file: filters.js:57 ~ percentSeparator ~ value:", value)
            let result = value + '%'
                // console.log("🚀 ~ file: filters.js:59 ~ percentSeparator ~ result:", result)
            return result
        }
    },
    fix(input, num) {
        return input && parseFloat(input).toFixed(num);
    },
    // 小数转成百分数
    toPercent(value) {
        if (value === 0) {
            return 0
        } else if (value) {
            return (value * 100) + '%';
        }
    },

}